import React from 'react';

import { BaseIconProps } from '.';

export const FaCheckCircle = ({ fill }: BaseIconProps) => (
  <path
    d="m 1080,540 c 0,298.2346 -241.7654,540 -540,540 C 241.7654,1080 0,838.2346 0,540 0,241.7654 241.7654,0 540,0 838.2346,0 1080,241.7654 1080,540 Z M 477.53855,825.92565 878.18371,425.28048 c 13.60452,-13.60451 13.60452,-35.66395 0,-49.26846 l -49.26847,-49.26847 c -13.60451,-13.6067 -35.66395,-13.6067 -49.27064,0 L 452.90323,653.48274 300.3554,500.93492 c -13.60451,-13.60452 -35.66395,-13.60452 -49.27064,0 l -49.26847,49.26847 c -13.60452,13.60451 -13.60452,35.66395 0,49.26846 L 428.2679,825.92347 c 13.6067,13.60669 35.66395,13.60669 49.27065,0.002 z"
    fill={fill}
  />
);
